import { showVROrbitView } from './vr-orbit-view-integration';
import { showVRViewBeforeAR } from './scene-builder';
import { xrFramework } from '../main';

const arCloseBtn = document.getElementById('arCloseBtn')!;
const arInstructionContainer = document.getElementById('ar-instruction-container')!;
export const arStartBtn = document.getElementById('ar-start-btn') as HTMLButtonElement;
const uiContainer = document.getElementById('ui-container')!;

export function initUI() {
  arCloseBtn.addEventListener('click', async () => {
    await showVROrbitView();
    showVROrbitUIElements();
  });
  arStartBtn.addEventListener('click', () => {
    showARUIElements();
  });
}

export function showARUIElements() {
  if (showVRViewBeforeAR || xrFramework === 'webxr') {
    arCloseBtn.style.display = 'block';
  } else {
    arCloseBtn.style.display = 'none';
  }
  uiContainer.style.pointerEvents = 'auto';
  arStartBtn.style.display = 'none';
}

export function showVROrbitUIElements() {
  arCloseBtn.style.display = 'none';
  arInstructionContainer.style.display = 'none';
  uiContainer.style.pointerEvents = 'none';
  arStartBtn.style.display = 'block';
}

export function setARInstructionContainerVisibility(visible: boolean) {
  arInstructionContainer.style.display = visible ? 'block' : 'none';
}

export function showARStartButtonAndAddListener(onClick: () => void) {
  arStartBtn.addEventListener('click', onClick);
  arStartBtn.style.display = 'block';
}
